/* eslint-disable no-shadow, no-unused-vars */
import { AccountsService } from './accounts.service';
import { AuthService } from './auth.service';
import { DatasetService } from './dataset.service';
import { IntegrationService } from './integration.service';
import { PatchworkService } from './patchwork.service';
import { AppService } from './app.service';
import { OrganizationService } from './organization.service';
import { TemplatesService } from './templates.service';
import { ViewService } from './view.service';
import { StyleService } from './style.service';
import { TranslationService } from './translation.service';
import { LanguageService } from './language.service';
import { PermissionService } from './permission.service';
import { MediaService } from './media.service';
import { GroupService } from './group.service';
import { UserService } from './user.service';
import { PushService } from './push.service';
import { PublicationService } from './publication.service';
import { BuildService } from './build.service';
import { SubdomainService } from './subdomain.service';
import { AnalyticsService } from './analytics.service';
import { BundleService } from './bundle.service';
import { DiscountsService } from './discounts.service';
import { DeveloperPlansService } from './developerplans.service';
import { PlatformService } from './platform.service';
import { PlatformVersionService } from './platformversion.service';
import { StateService } from './state.service';
import { EnvironmentService } from './environment.service';
import { StorageService } from './storage.service';
import { VariableService } from './variable.service';
import { SignupService } from './signup.service';
import { DatasetRuleService } from './datasetrule.service';
import { APIKeyService } from './apikey.service';
import { ResellerService } from './reseller.service';
import { AppDevPlanStatusService } from './appdevplanstatus.service';
import API from './utils/api';
import { TermService } from './term.service';
import { PolicyService } from './policy.service';
import { PushTemplateService } from './pushTemplate.service';
import { PushMultiAppsService } from './pushMultiApps.service';
import { UsersSharedAppsService } from './usersSharedApps.service';
export var createServices = function (useMockService, API, APIPush, APIAnalytics, APIBuild) { return ({
    AccountsService: new AccountsService(API),
    AuthService: new AuthService(API),
    DatasetService: new DatasetService(API),
    IntegrationService: new IntegrationService(API),
    PatchworkService: new PatchworkService(API),
    AppService: new AppService(API),
    OrganizationService: new OrganizationService(API),
    TemplatesService: new TemplatesService(API),
    ViewService: new ViewService(API),
    StyleService: new StyleService(API),
    TranslationService: new TranslationService(API),
    LanguageService: new LanguageService(API),
    PermissionService: new PermissionService(API),
    GroupService: new GroupService(API),
    UserService: new UserService(API),
    PublicationService: new PublicationService(API),
    BuildService: new BuildService(APIBuild),
    MediaService: new MediaService(API),
    PushService: new PushService(APIPush),
    SubdomainService: new SubdomainService(API),
    PolicyService: new PolicyService(API),
    TermService: new TermService(API),
    AnalyticsService: new AnalyticsService(APIAnalytics),
    BundleService: new BundleService(API),
    DiscountsService: new DiscountsService(API),
    DeveloperPlansService: new DeveloperPlansService(API),
    PlatformService: new PlatformService(API),
    PlatformVersionService: new PlatformVersionService(API),
    StateService: new StateService(API),
    EnvironmentService: new EnvironmentService(API),
    StorageService: new StorageService(API),
    VariableService: new VariableService(API),
    SignupService: new SignupService(API),
    DatasetRuleService: new DatasetRuleService(API),
    APIKeyService: new APIKeyService(API),
    ResellerService: new ResellerService(API),
    AppDevPlanStatusService: new AppDevPlanStatusService(API),
    PushTemplateService: new PushTemplateService(APIPush),
    PushMultiAppsService: new PushMultiAppsService(API),
    UsersSharedAppsService: new UsersSharedAppsService(API),
}); };
var ApiInstance = new API(process.env.API_BASE_URL, process.env.APT_VERSION);
var ApiPushInstance = new API(process.env.API_PUSH_BASE_URL, process.env.APT_VERSION);
var ApiAnalyticsInstance = new API(process.env.API_ANALYTICS_BASE_URL, process.env.APT_VERSION);
var ApiBuildInstance = new API(process.env.API_BUILD_BASE_URL, process.env.APT_VERSION);
export default createServices(process.env.USE_MOCK_SERVICE === 'true', ApiInstance, ApiPushInstance, ApiAnalyticsInstance, ApiBuildInstance);
var api401Callbacks = [];
var api403Callbacks = [];
var apiGenericCallbacks = [];
export var injectApi401Callback = function (cb) {
    api401Callbacks.push(cb);
    return function () {
        api401Callbacks = api401Callbacks.filter(function (m) { return m !== cb; });
    };
};
export var injectApi403Callback = function (cb) {
    api403Callbacks.push(cb);
    return function () {
        api403Callbacks = api403Callbacks.filter(function (m) { return m !== cb; });
    };
};
export var injectApiGenericCallback = function (cb) {
    apiGenericCallbacks.push(cb);
    return function () {
        apiGenericCallbacks = apiGenericCallbacks.filter(function (m) { return m !== cb; });
    };
};
ApiInstance.injectApi401Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api401Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiInstance.injectApi403Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api403Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiInstance.injectApiGenericCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    apiGenericCallbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiPushInstance.injectApi401Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api401Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiPushInstance.injectApi403Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api403Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiPushInstance.injectApiGenericCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    apiGenericCallbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiAnalyticsInstance.injectApi401Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api401Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiAnalyticsInstance.injectApi403Callback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    api403Callbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
ApiAnalyticsInstance.injectApiGenericCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    apiGenericCallbacks.forEach(function (cb) { return cb.apply(void 0, args); });
});
